import axios from 'axios';
import { API_PROFILE_HEADER } from '@/constants/api';
import { getItem } from '@/helpers/storage';

axios.defaults.baseURL = 'https://easy-play.cc/';

axios.interceptors.request.use((config) => {
  const token = getItem('accessToken');
  const profile = getItem('currentProfile');

  config.headers.Authorization = `Bearer ${token ?? ''}`;

  if (profile?.profile_number && !config.withoutProfileHeader) {
    config.headers[API_PROFILE_HEADER] = Number(profile.profile_number);
  }

  return config;
});

export default axios;
